import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { body, scrolled } from "./tile.module.scss";

const SCROLL_THRESHOLD = 2;

const TileBody = ({ className, ...props }) => {
  const [isScrolled, setScrolled] = useState(false);

  return (
    <div
      onScroll={({ target }) => { setScrolled(target.scrollTop > SCROLL_THRESHOLD); }}
      className={classNames(body, { [scrolled]: isScrolled }, className)}
      {...props}
    />
  );
};

TileBody.propTypes = {
  className: PropTypes.string
};

TileBody.defaultProps = {
  className: ""
};

export default TileBody;
